import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-[#0a192f] text-gray-300">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-pink-600">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold">
            <p>
              Hi. I'm Kalaiselvi, nice to meet you. Please take a look around.
            </p>
          </div>
          <div>
            <p>
              I am a passionate developer dedicated to building high-quality
              software that solves real-world problems. Having spent 4 years
              mastering frontend development with ReactJS and modern JavaScript,
              I have expanded my toolkit into full-stack development using
              Node.js, Express, and MongoDB. Whether designing responsive user
              interfaces, integrating state management with TanStack, or
              developing secure backend APIs, I enjoy bringing ideas to life
              from concept to deployment.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
